export default {
    type: 'testimonial-testimonial-categories',
    aliases: {
        camel: 'testimonialTestimonialCategories',
        singular: 'Testimonial testimonial category',
        plural: 'Testimonial testimonial categories',
        lowerSingular: 'testimonial testimonial category',
        lowerPlural: 'testimonial testimonial categories',
    },
    publishable: false,
    adminSection: null,
    componentType: 'pivot',
    components: {}
};
